// Seleção em lote da grade de Tudo e arrasto de cards (para Em foco, para o nome de uma coleção, dentro da coleção).
import { effect, signal } from "@preact/signals";
import { go } from "../state.ts";
import { rangeIds } from "./order.ts";

export const selecting = signal(false);
export const selected = signal<ReadonlySet<string>>(new Set());
let anchor: string | null = null;
effect(() => void document.documentElement.toggleAttribute("data-selecting", selecting.value));

export function stopSelecting() {
  selecting.value = false;
  selected.value = new Set();
  anchor = null;
}
/** Clique num card no modo seleção. `range` (shift) vai do último clicado até este, na ordem da grade. */
export function toggleSelect(id: string, order: string[], range = false) {
  const next = new Set(selected.peek());
  if (range && anchor) for (const x of rangeIds(order, anchor, id)) next.add(x);
  else if (next.has(id)) next.delete(id);
  else next.add(id);
  anchor = id;
  selected.value = next;
}
export function selectAll(ids: string[]) {
  selected.value = new Set(ids);
}
/** Shift/Ctrl/⌘ + clique (ou Shift+Enter) num card fora do modo seleção: entra no modo com ele. true = tratou. */
export function modifierPick(e: MouseEvent, id: string, order: string[]): boolean {
  if (!(e.shiftKey || e.ctrlKey || e.metaKey) || e.button) return false;
  e.preventDefault();
  if (!selecting.peek()) stopSelecting();
  selecting.value = true;
  toggleSelect(id, order, e.shiftKey);
  return true;
}

/** Tipo próprio no arrasto: o navegador não vê URL nem arquivo, então o "soltar para guardar" do app ignora. */
export const CARD_MIME = "application/x-faig-cards";
/** Ids sendo arrastados agora (a faixa Em foco aparece vazia para receber; os nomes das coleções acendem). */
export const dragging = signal<string[] | null>(null);
export function startCardDrag(e: DragEvent, ids: string[]) {
  const dt = e.dataTransfer;
  if (!dt) return;
  dt.clearData(); // o <a> do card põe a própria URL; sem ela, soltar fora não vira card de link
  dt.setData(CARD_MIME, ids.join("\n"));
  dt.effectAllowed = "copyMove";
  dragging.value = ids;
}
export const endCardDrag = () => void (dragging.value = null);
export const isCardDrag = (e: DragEvent) => !!e.dataTransfer?.types.includes(CARD_MIME);
export const droppedIds = (e: DragEvent) => (e.dataTransfer?.getData(CARD_MIME) ?? "").split("\n").filter(Boolean);
/** Ids do arrasto vindo de um card da grade: os selecionados, se ele estiver entre eles. */
export const dragIdsFor = (id: string) => (selecting.peek() && selected.peek().has(id) ? [...selected.peek()] : [id]);

/** Link interno: clique simples navega sem recarregar; com modificador fica com o navegador. */
export const navTo = (path: string) => (e: MouseEvent) => {
  if (e.button || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
  e.preventDefault();
  go(path);
};
